function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1464 -6448)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 34",
    width: 40,
    height: 40,
    rx: 20,
    transform: "translate(1464 6448)",
    style: {
      fill: "#133b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4 9H14V7c0-1.032.084-1.682 1.563-1.682h.868a1 1 0 0 0 1-1V3.064a1 1 0 0 0-.923-1Q15.6 2 14.693 2A4.374 4.374 0 0 0 10 6.7V9H8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-8h2.174a1 1 0 0 0 .993-.886l.229-2A1 1 0 0 0 16.4 9z",
    transform: "translate(1472 6456)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.92ef93fa99fd7fe08ec797f6c0f76686.svg";
export { ForwardRef as ReactComponent };